<template>
<div class="app-container">
    <!-- 查询区域 -->
    <el-form  :model="queryPara" ref="queryForm" :inline="true" size="small" v-show="showSearch">

        <el-row>
            <el-form-item label="查询时间">
                <el-date-picker
                    v-model="queryPara.bidDateRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="报案号">
                <el-input v-model="queryPara.caseSn" placeholder="请输入报案号" clearable></el-input>
            </el-form-item>
            <!-- 通过下拉选择 -->
            <el-form-item label="保险公司">
                <!-- value-key="modelName" -->
                <el-autocomplete
                    v-model="queryPara.insurance.insureCompany"
                    :fetch-suggestions="querySearchInsureCompany"
                    value-key="insureCompanyName"
                    placeholder="请输入保险公司"
                    clearable
                ></el-autocomplete>

               
            </el-form-item>

            <el-form-item label="分公司">
                <el-input v-model="queryPara.insurance.insureFiliale" placeholder="请输入保险分公司" clearable></el-input>
            </el-form-item>
        </el-row>

        <el-row>
            <el-form-item label="登记时间">
            <el-date-picker
                v-model="queryPara.regDateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="-"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            </el-form-item>
            
            <el-form-item label="车牌号">
                <el-input v-model="queryPara.current.plateNo" placeholder="请输入车牌号" clearable></el-input>
            </el-form-item>

            <el-form-item label="车架号">
                <el-input v-model="queryPara.factory.vin" placeholder="请输入车架号" clearable></el-input>
            </el-form-item>
            <el-form-item label="车辆编号">
                <el-input v-model="queryPara.vehicleSn" placeholder="请输入车辆编号" clearable></el-input>
            </el-form-item>
            
        </el-row>

        <el-row>
              <el-form-item label="内部车型">

                <el-autocomplete
                    v-model="queryPara.factory.vehicleTradeName"
                    :fetch-suggestions="querySearchModelName"
                    value-key="modelName"
                    placeholder="请输入车辆型号"
                  
                    ></el-autocomplete>
            </el-form-item>
           

            <el-form-item label="车辆级别">
                <el-select v-model="queryPara.check.vehicleLevel" placeholder="请选择车辆级别" clearable>
                    <el-option
                        v-for="dict in dict.type.vehicle_level"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                        />
                </el-select>
            </el-form-item>
        
            

            <el-form-item label="区域">
                <el-select v-model="queryPara.check.district" placeholder="请选择区域" clearable>
                    <el-option
                        v-for="dict in dict.type.vehicle_district"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                        />
                </el-select>
            </el-form-item>

        </el-row>
        
        <el-row>

            <el-form-item label="状态">
                <el-select v-model="queryPara.caseStatus" placeholder="是否审核" clearable>

                    <el-option
                        v-for="dict in dict.type.vehicle_case_status"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                        />
                </el-select>
            </el-form-item>

            
            <el-form-item label="中标公司">

                <el-select v-model="queryPara.bidCompany" placeholder="请选择中标公司" clearable>
                    <el-option
                        v-for="dict in dict.type.vehicle_bid_company"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.label"
                        />
                </el-select>

            </el-form-item>
            
        </el-row>

        <el-form-item>
            <el-button size="mini" type="primary" icon="el-icon-refresh" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini"  @click="handleReset">重置</el-button>
        </el-form-item>
    </el-form>

    <!-- 按钮操作区域 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="showAddView"
          v-hasPermi="['system:dept:add']"
        >新增</el-button>
      </el-col>
      
      <!-- 
      <el-col :span="1.5">
        <el-button
          type="info"
          plain
          icon="el-icon-sort"
          size="mini"
          @click="toggleExpandAll"
        >展开/折叠</el-button>
      </el-col>
       -->
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <!-- 1 table区域 -->
    <el-table 
    :data="listData"
    
    :row-class-name="backgroundRowClassName" 
    v-if="refreshTable" 
    v-loading="loading" 
    @sort-change="sortChange"
    :default-expand-all="isExpandAll"
    element-loading-text="正在查询中...">
        <el-table-column label="序号" type="index" width="50" >

        </el-table-column>
        
        <!-- <el-table-column label="创建时间" prop="createTime" width="0">
        </el-table-column> -->

        <el-table-column label="案件ID" prop="caseId" width="100" sortable="custom">

        </el-table-column>

        <el-table-column label="级别" prop="check.vehicleLevelGrade" width="60">
        </el-table-column>
        <el-table-column label="事故类型" prop="check.vehicleLevel" width="80">
        </el-table-column>

        <el-table-column label="询价时间" sortable="custom" width="160" prop="bidStartTime" >
        
            <!-- <template v-slot="slotProps">
                {{parseTime(slotProps.row.bidStartTime,'{y}-{m}-{d}')}}
            </template> -->
        </el-table-column>

        <el-table-column label="逾期时间" sortable="custom" width="160" prop="bidEndTime">
            <!-- <template v-slot="slotProps">
                {{parseTime(slotProps.row.bidEndTime,'{y}-{m}-{d}')}}
            </template> -->
        </el-table-column>
        <el-table-column label="保险公司" prop="insurance.insureCompany"></el-table-column>
        <el-table-column label="车牌照号" prop="current.plateNo"></el-table-column>
        <el-table-column label="登记日期"  width="100">
            <template v-slot="slotProps">
                {{parseTime(slotProps.row.factory.registerDate,'{y}-{m}-{d}')}}
            </template>
        </el-table-column>
        <el-table-column label="车辆型号" prop="factory.vehicleTradeName">
            
        </el-table-column>
        
        <el-table-column label="区域" prop="check.district">
            <template slot-scope="scope">
                <dict-tag :options="dict.type.vehicle_district" :value="scope.row.check.district"/>
            </template>

        </el-table-column>

        <el-table-column label="投标金额" width="80"  >
            <template v-slot="slotProps">
                <div>
                 {{slotProps.row.bidChoose.bidSubmitPrice}}
                <el-tooltip  v-if="slotProps.row.bidChoose.bidSubmitPriceIn!=slotProps.row.bidChoose.bidSubmitPrice" :content="slotProps.row.bidChoose.bidSubmitPriceIn" placement="top">
                    <i class="el-icon-info"></i>
                     
                </el-tooltip>
                </div>
            </template>
        </el-table-column>
        
        <el-table-column label="中标公司" prop="bidCompany">
        </el-table-column>

        <el-table-column label="中标价格" width="80"  prop="bidPrice">

            <template v-slot="slotProps">
                <div>
                 {{slotProps.row.bidPrice}}
                 
                <el-tooltip v-if="slotProps.row.bidPriceIn!=slotProps.row.bidPrice" :content="slotProps.row.bidPriceIn" placement="top">
                    <i class="el-icon-info"></i>
                     
                </el-tooltip>
                </div>
            </template>
        </el-table-column>
        
        <el-table-column label="状态" prop="caseStatus" width="80">
            <template slot-scope="scope">
                <dict-tag :options="dict.type.vehicle_case_status" :value="scope.row.caseStatus"/>
            </template>
        </el-table-column>

        <el-table-column label="操作" width="250" fixed="right">
            <template v-slot="slotProps">
                <!-- 修改的功能 -->
                <el-button 
                    size="mini" 
                    type="success" 
                    @click="showUpdateView(slotProps.row)"
                    v-hasPermi="['vehicle:case:edit']"
                >编辑</el-button>
                
                <!-- 详情的功能 -->
                <el-button size="mini" type="primary" 
                v-hasPermi="['vehicle:case:detail']"
                @click="showDetailView(slotProps.row)"
                >详情</el-button>
                <!-- 停止报价，然后才可以给保险公司报价 -->
                <el-button 
                v-hasPermi="['vehicle:case:stop']"
                v-show="showStopQuoteButton(slotProps.row.caseStatus)"  
                @click="doStopQuote(slotProps.row)" 
                size="mini" 
                type="danger"
                >停止报价</el-button>
                
                <!-- 给保险公司报价 -->
                <el-button
                size="mini" 
                type="success" 
                @click="showSubmitBidView(slotProps.row)"
                v-hasPermi="['vehicle:case:submit']"
                v-show="showSubmitBidButton(slotProps.row.caseStatus)" > 提交报价</el-button>
                <!-- 手动添加保险公司的中标结果 
                      
                -->
                <el-button
               
                @click="showSubmitBidResult(slotProps.row)"
                size="mini"
                type="primary"
                v-hasPermi="['vehicle:case:SubmitBidResult']"
                v-show="showSubmitBidResultButton(slotProps.row.caseStatus)">
                中标结果
                </el-button>

                <!-- 添加委托信息 -->
                <el-button 
                v-show="showEntrustButton(slotProps.row.caseStatus)" 
                size="mini" 
                type="primary"
                @click="showEntrustView(slotProps.row)"
                v-hasPermi="['vehicle:case:entrust']">委托</el-button>

                <!-- 添加入库信息 -->
                <el-button 
                v-show="showStorageButton(slotProps.row.caseStatus)"
                size="mini"
                type="success"
                @click="showStorageView(slotProps.row)"
                v-hasPermi="['vehicle:case:storage']">入库</el-button>
                
               
                <el-row>
                 
                <el-button size="mini" 
                v-show="slotProps.row.collectFlag!='Y'"
                type="text"  @click="handleConfirmCollect(slotProps.row)">标记</el-button>
                <el-button size="mini" type="text"  
                v-show="slotProps.row.collectFlag=='Y'"
                @click="handleCancelCollect(slotProps.row)">取消标记</el-button>   
                
                <el-button 
                v-show="showAgainSubmitBidView(slotProps.row.caseStatus)"
                @click="showSubmitBidView(slotProps.row)" 
                size="mini" 
                type="text" 
                icon="el-icon-delete"
                v-hasPermi="['vehicle:case:AgainSubmit']"
                > 重新提交报价</el-button>

                <el-button 
                @click="handleRemove(slotProps.row)" 
                    type="text"
                    icon="el-icon-delete"
                    v-hasPermi="['vehicle:case:remove']"
                    size="mini"
                >删除</el-button>
                 
                </el-row>


            </template>
        </el-table-column>
        
    </el-table>
    
    <!-- 分页区域 -->
    <pagination  v-show="totalRow>0" :total="totalRow" :page.sync="page.pageNumber" 
        :limit.sync="page.pageLimit" 
        @pagination="getList">
    </pagination>
    
    <!-- 提交中标结果组件 -->
    <bid-result-dialog :show-status="showSubmitBidResultStatus"
        @close="closeSubmitBidResultDialog"
        :case-obj="caseDetailObj">
    </bid-result-dialog>
    <!-- 提交委托信息 -->
    <vehicle-entrust-dialog :show-status="showEntrustStasus"
        @close="showEntrustStasus=false"
        :case-obj="caseDetailObj">
    </vehicle-entrust-dialog>
</div>
</template>
<!-- 
对车辆案件进行管理

 -->
<script>
import Const from '@/utils/constant'
import {parseTime} from '@/utils/ruoyi'

import {listCase,stopCaseQuote,removeCase,confirmCollectCase,cancelCollectCase} from '@/api/vehicle/case'
import {getVehileModelList} from '@/api/vehicleConfig/vehicleModel'
import {listInsurance} from '@/api/vehicleConfig/insurance'
import Pagination from '@/components/Pagination'
import BidResultDialog from "@/views/vehicleInsure/vehicleBidResultDialog/index.vue"
import VehicleEntrustDialog from "@/views/vehicleInsure/vehicleEntrustDialog/index.vue"
export default {
    name: "/vehicle-insure/list",//车辆保险 列表
    dicts:['sys_yes_no','sys_normal_disable','vehicle_case_status','vehicle_district','vehicle_level','vehicle_bid_company'],
    components:{Pagination,BidResultDialog,VehicleEntrustDialog},
    data(){
        return{
            constData:Const,
            // 是否展开，默认全部展开
            isExpandAll: true,
            // 重新渲染表格状态
            refreshTable: true,
            // 遮罩层
            loading: true,
            // 显示搜索条件
            showSearch: true,
            queryPara:{
                //保险公司部门
                caseSn:'',//报案号
                bidDateRange:[],//竞价时间范围
                vehicleSn:'',//车辆编号
                bidCompany:'', //中标公司
                // 保险公司信息
                insurance:{
                    insureCompany:'',//保险公司
                    insureFiliale:'',//保险分公司
                },
                
                //车辆信息
                
                current:{
                    plateNo:'',//车牌号
                },
               
                factory:{
                    vin:'',//车架号
                    vehicleTradeName:'',
                },
                regDateRange:[],//车辆登记日期
                queryPara:'',
              
                clientContact:'',
                check:{
                    isCheck:'',
                    vehicleLevel:'',
                    district:'',
                },
                caseStatus:'',//案件状态
                orderSort:'ascending',
                columnName:'',
            },
            
            listData:[],
            totalRow: 0,
            page: {
                pageNumber: 1,
                pageLimit: 10,
            },
            caseDetailObj:{},//案件对象的详细信息
            showSubmitBidResultStatus:false, //显示提交报价dialog
            showEntrustStasus:false,
        }
    },
    created(){
        this.handleQuery();
    },
   
    methods:{

         /** 展开/折叠操作 */
        toggleExpandAll() {
            this.refreshTable = false;
            this.isExpandAll = !this.isExpandAll;
            this.$nextTick(() => {
                this.refreshTable = true;
            });
        },
        
        //重置
        handleReset(){
            this.queryPara={
                //保险公司部门
                caseSn:'',//报案号
                bidDateRange:[],//竞价时间范围
                vehicleSn:'',//车辆编号
                bidCompany:'', //中标公司
                // 保险公司信息
                insurance:{
                    insureCompany:'',//保险公司
                    insureFiliale:'',//保险分公司
                },
                
                //车辆信息
                
                current:{
                    plateNo:'',//车牌号
                },
               
                factory:{
                    vin:'',//车架号
                    vehicleTradeName:'',
                },
                regDateRange:[],//车辆登记日期
                queryPara:'',
              
                clientContact:'',
                check:{
                    isCheck:'',
                    vehicleLevel:'',
                    district:'',
                },
                caseStatus:'',//案件状态
                orderSort:'ascending',
                columnName:'',
            };
        },

        //按照某个字段 排序
        sortChange({column,prop,order}){  
            column.multiOrder=order;
            
            if(column.sortable!=='custom'){
                return;
            }

            this.queryPara.orderSort=order;
            this.queryPara.columnName=prop;
            this.handleQuery();

        },

        //查询
        handleQuery(){
            this.page.pageNumber=1;
            this.getList();
        },
        
        //获取列表
        getList(){
            this.loading = true;
            var para=Object.assign(this.queryPara,this.page)
            para=this.addDateRange(para,this.queryPara.bidDateRange,"bid")
            para=this.addDateRange(para,this.queryPara.regDateRange,"reg")
            listCase(para).then(res=>{
                this.loading = false;
                this.totalRow=res.data.totalRow;
                this.listData=res.data.list;
            })
        },

        /**
         * 显示增加View
         */
        showAddView(){
            this.$router.push({ path: '/vehicle-insure/add'});
        },

        /**
         * 显示修改界面
         * @param {*} para 
         */
        showUpdateView(para){
            this.$router.push({ path: '/vehicle-insure/edit',query:{caseid: para.caseId}});
        },

       /**
        * 显示详情界面
        * @param {*} para 
        */
        showDetailView(para){
            this.$router.push({ path: '/vehicle-insure/detail',query:{caseid: para.caseId,date:new Date().getTime()}});
        },

        //删除
        handleRemove(row){
            
            this.$confirm('确定要删除id为:'+row.caseId+';您确定要继续吗?', '提示', {  
                confirmButtonText: '确定',  
                cancelButtonText: '取消',  
                type: 'warning'  
            }).then(() => {  
                // 
               
                removeCase({"caseId":row.caseId}).then(res=>{
                    if(res.success){
                        //提交成功，改变状态
                        
                        // this.listData(para.index).caseStatus=constData.CASE_STATUS_BIDDIND
                    }else{

                    }
                })
                .catch(error=>{

                })
            }); 
        },

        //进行收藏
        handleConfirmCollect(row){
           
            this.$confirm('确定要收藏id为:'+row.caseId+';您确定要继续吗?', '提示', {  
                confirmButtonText: '确定',  
                cancelButtonText: '取消',  
                type: 'warning'  
            }).then(() => {  
                confirmCollectCase({"caseId":row.caseId,"collectFlag":'Y'}).then(res=>{
                    if(res.success){
                        //收藏成功，把此row放入
                        row.collectFlag="Y"
                    }
                })
                .catch(error=>{

                })
            }); 
        },
        //取消收藏
        handleCancelCollect(row){
            this.$confirm('确定取消收藏id为:'+row.caseId+';您确定要继续吗?', '提示', {  
                confirmButtonText: '确定',  
                cancelButtonText: '取消',  
                type: 'warning'  
            }).then(() => {  
                cancelCollectCase({"caseId":row.caseId,"collectFlag":'N'}).then(res=>{
                    if(res.success){
                        row.collectFlag="N"
                    }
                })
                .catch(error=>{

                })
            }); 
        },
        // 收藏，标记颜色
        backgroundRowClassName({ row, rowIndex }){
            
            if (row.collectFlag === 'Y') {
                return 'collect-row' // 
            }
            return '' // 其他状态没有特殊类
        },

        /**
         * 显示 停止报价 的Button
         * 会员报价中-停止报价
         */
        showStopQuoteButton(status){
            if(status===this.constData.CASE_STATUS_QUOTATION){
                return true;
            }else{
                return false;
            }
        },
        /**
         * 显示提交报价的 Button 
         * 把价格提交给保险公司
         */
        showSubmitBidButton(status){
            if(this.constData.CASE_STATUS_BIDDING===status){
                return true;
            }else{
                return false;
            }
        },
        
        /**
         * 
         * @param status 
         */
        showAgainSubmitBidView(status){
            if(this.constData.CASE_STATUS_BIDDED===status ){
                return true;
            }else{
                return false;
            }
        },
        /**
         * 显示获取报价结果的Button
         * 手动填写填写中标结果；
         * 对有些没有接口，要填写。 
         */
        showSubmitBidResultButton(status){
            if(this.constData.CASE_STATUS_BIDDED===status ){
                return true;
            }else{
                return false;
            }
        },


        /***
         * 显示委托button
         * 中标后进行委托
         */
        showEntrustButton(status){
            if(this.constData.CASE_STATUS_OUTBID===status ){
                return true;
            }else{
                return false;
            }
        },

        /**
         * 显示入库Button
         * 委托完进行入库
         */
        showStorageButton(status){
            if(this.constData.CASE_STATUS_ENTRUST===status ){
                return true;
            }else{
                return false;
            }
        },

        /**
         * 进行停止报价
         */
        doStopQuote(para){
            
            this.$confirm('确定要停止报价;停止后会员不能报价;您确定要继续吗?', '提示', {  
                confirmButtonText: '确定',  
                cancelButtonText: '取消',  
                type: 'warning'  
            }).then(() => {  
                // 
                stopCaseQuote(para.caseId).then(res=>{
                    if(res.success){
                        //提交成功，改变状态
                        console.log(para);
                        // this.listData(para.index).caseStatus=constData.CASE_STATUS_BIDDIND
                    }else{

                    }
                })
                .catch(error=>{

                })
            }); 
        },

        /**
           * 显示提交报价界面
           * 要给保险公司报价
           * @param {*} para 
        */
        showSubmitBidView(para){
            this.$router.push({ path: '/vehicle-insure/submit',query:{caseid: para.caseId}});
        },

        /**
         * 显示中标结果dialog 
         */
        showSubmitBidResult(para){
            this.caseDetailObj=para;
            this.showSubmitBidResultStatus=true;
        },

        // 关闭对话框
        closeSubmitBidResultDialog(para){
            this.showSubmitBidResultStatus=false;
        },

        /**
         *显示委托界面 
         */
        showEntrustView(para){
            this.caseDetailObj=para;
            this.showEntrustStasus=true;
        },

        /**
         *  显示入库界面 
         */
        showStorageView(para){
            this.$router.push({ path: '/vehicle-insure/storage',query:{caseid: para.caseId}});
        },

        /**
         * 搜索车辆型号的名字
         */
        querySearchModelName(queryString, callback){
            var para={"modelName":queryString};
            getVehileModelList(para).then(res=>{
                callback(res.data);
            })
        },

        querySearchInsureCompany(queryString,callback){
            var para={"insureCompany":queryString};
            listInsurance(para).then(res=>{
             
                callback(res.data);
            })
        }
    }
}
</script>
<style >
    .wrapper{
		margin-left: 5%;
		margin-right: 5%;
	}
    
    .app-container .collect-row {
        background: rgb(126, 182, 247) !important; /* 浅黄色背景 */
    }

  
   
</style>


